<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button  @click="load">刷新</Button>
            <Button type="primary" @click="modal1=true">修改生成数量</Button>
            <Button type="error" @click="remove">清空当前列表</Button>
            <cite>|</cite>
            <a href="/api/export/outexcel?id=5" target="_blank">导出当前列表数据</a>
            <cite>|</cite>
            当前生成发件箱数量：<b>{{num}}</b>

          </Col>
          <Col span="5">
<!--             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>-->
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="编号" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="outbox" label="发件箱" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="password" label="密码" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="client_ip" label="服务器IP" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="client_password" label="服务器密码" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="updateTime" label="最后一次清理时间" :show-tooltip-when-overflow="true"></el-table-column>

<!--        <el-table-column prop="msg" label="操作" width="120" fixed="right">-->
<!--          <template slot-scope="scope">-->
<!--            <a @click="edit(scope.row.id)">编辑</a>-->
<!--            <cite>|</cite>-->
<!--            <a @click="remove(scope.row.id)">删除</a>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <p style="margin-top: 10px;font-size: 12px">使用说明：当设置的生成数量为3时，当前平台中所有的服务器（无法链接的除外），每个服务器会生成3个发件箱，若当前列表中，某个服务器已生成2个，则只会再生成一个发件箱。
    <br/>设置后控制台会在后台操作，若当前控制台繁忙，生成发件箱可能会排队处理，正常情况设置后会在1到6分钟内处理，最晚不会超过10分钟。
    </p>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="80">
       	<FormItem label="生成数量" required>
					<Input v-model="num2"/>
          <p>生成数量：每个服务器生成发件箱的数量</p>
				</FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        baseUrl:'/api/outboxs/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
        num:0,//生成数量
        num2:0,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });

        this.$axios.get(this.baseUrl+'getnum').then(function(rs){
          that.num = rs.data;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.$axios.get(this.baseUrl+'upnum?num='+this.num2).then(function(rs){
          that.toast(rs.data);
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要清空当前列表吗（此操作不可撤销）',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'truncate').then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/outboxs/Outboxs.vue